import { Flex } from "@chakra-ui/react";
import TagStatus from "./TagStatus";
import { GoAlert } from "react-icons/go";
import { ClienteContrato, TipoContrato } from "core/features/cliente/typings";
import colors from "core/resources/theme/colors";

interface ContentTagProps {
  item?: ClienteContrato;
}

export default function ContentTag({ item }: ContentTagProps) {
  return (
    <Flex gap={6} mt={4}>
      {item?.tipoContrato === TipoContrato.Aluguel ? (
        <Flex
          rounded={5}
          px={3}
          py={1}
          border={`solid 2px ${colors.primary}`}
          color={colors.primary}
        >
          Aluguel
        </Flex>
      ) : (
        <Flex
          rounded={5}
          px={3}
          py={1}
          border={`solid 2px ${colors.primary}`}
          color={colors.primary}
        >
          Venda
        </Flex>
      )}
      {item?.inadimplente ? (
        <TagStatus colorScheme="red" title="Inadimplente" icon={<GoAlert />} />
      ) : null}

      {item?.contaAtraso ? (
        <TagStatus
          colorScheme="gray"
          title={`${item?.contaAtraso} ${
            item?.contaAtraso > 1 ? " contas " : " conta "
          } em atraso`}
        />
      ) : null}

      {item?.tempoFimContrato ? (
        <TagStatus
          colorScheme="gray"
          title={`${item?.tempoFimContrato} ${
            item?.tempoFimContrato > 1 ? "dias " : " dia "
          } do fim do contrato`}
        />
      ) : null}
    </Flex>
  );
}
